export class PopoverOption {
	id: any;
	title: string;
	subtitle?: string;

	constructor(id: any, title: string, subtitle?: string) {
		this.id = id;
		this.title = title;
		this.subtitle = subtitle;
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/components/popover/popover.model.ts